import classNames from 'classnames'
import { Investment } from 'entities-next/fundingRounds'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

import { getUserName } from '../../../../../../../../../../../../../entities-next/user'

export type InvestmentViewProps = ExtendableStyles &
  Testable & {
    data: Investment
  }

export function InvestmentView({ className, data, ...otherProps }: InvestmentViewProps) {
  const { classes } = useStyles()
  const investor = useInvestmentViewData(data)
  return (
    <div className={classNames(className, classes.container)} {...otherProps}>
      <Typography className={classes.label}>{data.isLead ? 'Lead investor' : 'Investor'}:</Typography>
      {investor && <Typography>{investor}</Typography>}
    </div>
  )
}

function useInvestmentViewData(data: Investment) {
  if (data.person) {
    return getUserName(data.person)
  } else if (data.organization) {
    return data.organization.name
  } else {
    return undefined
  }
}

const useStyles = makeStyles()(({ spacing, typography }: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontWeight: typography.fontWeightBold,
    marginRight: spacing(),
  },
}))
